export const GOOGLE_MAPS_CONFIG = {
    id: "google-maps",
    version: "3.64",
    libraries: ["places", "drawing", "visualization"] as const,
    language: "pt-BR",
    region: "BR",
}
